const STORAGE_KEY = "bic_cache_owner";

/** The persisted caches were purged on explicit sign-out, so nobody owns them. */
export const UNOWNED_CACHE_OWNER = "none";

export const loadCacheOwner = (): string | null =>
  localStorage.getItem(STORAGE_KEY);

export const saveCacheOwner = (owner: string): void => {
  localStorage.setItem(STORAGE_KEY, owner);
};
